module.exports = require('./helpers/bundle-url').getBundleURL('04OEz') + "logo-dark.eefe0b7f.svg";